<template>
  <table class="border-separate border-gray-200" style="border-spacing: 0 0.75rem">
    <slot />
  </table>
</template>
